import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DisplayOptionsMode } from 'src/app/constants/display-mode';
import { GeneralOption } from 'src/app/models/general-option.t';

@Component({
  selector: 'tr[app-tr]',
  templateUrl: './tr.component.html',
  styleUrls: ['./tr.component.css']
})
export class TrComponent implements OnInit {

  @Input()
  label: string | undefined = '';

  @Input()
  value: string | undefined = '';

  @Input()
  width: string = 'col-md-3';

  @Input()
  fc: FormControl | undefined;

  @Input()
  inputType: string = 'text';

  @Input()
  options: GeneralOption[] | undefined;

  @Input()
  date: Date | undefined;

  @Input()
  selected: number = 0;

  @Input()
  isReadonly: boolean = false;

  @Input()
  displayOptionsMode: number = DisplayOptionsMode.NAME;

  fieldName: string = '';

  constructor() { }

  ngOnInit(): void {
    this.fieldName = (this.label || '').toLocaleLowerCase().replace(/ /g, '_');;
  }

  getErrorMessage(fc: FormControl) {
    if (fc.hasError('required')) {
      return 'Harus diisi';
    }

    return '';
  }

  displayOption(option: GeneralOption) {
    switch (this.displayOptionsMode) {
      case DisplayOptionsMode.CODE:
        return option.code;
      case DisplayOptionsMode.NAME_CODE:
        return `${option.code} - ${option.name}`;
      default:
        return option.name;
    }
  }
}
